import { Circle } from '@visx/shape';
import { scaleLinear } from '@visx/scale';
import { extent } from "d3-array";
import { AxisLeft, AxisBottom } from '@visx/axis';
import SvgPlotWrapper from "../svg-plot-wrapper/svg-plot-wrapper.component";
import LogoWithText from "../logo-with-text/logo-with-text.component"

const EmbeddingsPlot = ({ 
    embeddingData, 
    dimensions, 
    isMedium, 
    selectedEmbeddingIndex, 
    shownQuestionIndices,
}) => {

    const xExtent = extent(embeddingData, d => d[0]);
    const xRange = xExtent[1] - xExtent[0];
    const xScale = scaleLinear({
        domain: [xExtent[0] - xRange / 10, xExtent[1] + xRange / 10],
        range: [0, dimensions.innerWidth]
    });
    const yExtent = extent(embeddingData, d => d[1]);
    const yRange = yExtent[1] - yExtent[0];
    const yScale = scaleLinear({
        domain: [yExtent[0] - yRange / 10, yExtent[1] + yRange / 10],
        range: [dimensions.innerHeight, 0]
    });

    return (
        <SvgPlotWrapper dimensions={dimensions}>
            <LogoWithText innerWidth={dimensions.innerWidth} innerHeight={dimensions.innerHeight} />
            <AxisLeft
                scale={yScale}
                label={'t-SNE dimension 2'}
                labelOffset={isMedium === false && 15}
                numTicks={0}
                labelProps={{ style: { fontSize: 16, textAnchor: 'middle' } }}
            />
            <AxisBottom
                top={dimensions.innerHeight}
                scale={xScale}
                hideTicks={true}
                label={'t-SNE dimension 1'}
                labelOffset={isMedium === false && 15}
                numTicks={0}
                labelProps={{ style: { fontSize: 16, textAnchor: 'middle' } }}
            />
            {
                embeddingData.length > 0 &&
                <>
                    {
                        embeddingData.map((point, i) => (
                            shownQuestionIndices.includes(i) &&
                            <Circle
                                key={`point-${i}`}
                                cx={xScale(point[0])}
                                cy={yScale(point[1])}
                                r='7'
                                strokeWidth={0}
                                opacity={i === selectedEmbeddingIndex ? 1 : 0.2}
                                fill={'black'}
                            />
                        ))
                    }
                </>
            }
        </SvgPlotWrapper>)
}

export default EmbeddingsPlot;